import buildPermEnum from './permissions';

import {
  objNotEmpty,
  isString,
  memoize
} from '@/utils';

const PERMISSIONS = buildPermEnum();
// tmp, will refine into a private npm pkg, but works fine for now

/**
 * @summary Map permissions string to an array corresponding, readable permissions
 * @param {object} perms an object containing the raw permissions,
 * where key is the permissions set and value is the permissions string
 * @returns {array}
 */
export default function translatePermissions (perms) {
  if (!objNotEmpty(perms)) return [];

  const m = [];
  const hashMapped = memoize(mapPermission);
  for (const [k, v] of Object.entries(perms)) {
    m.push(...hashMapped(v, k).parse());
  }
  return m;
}

/* Helpers */

/**
 * @summary convert hex-like perm char to base 10 int
 * @returns {number}
 */
function getFlagsFromChar (char) {
  return '0123456789ABCDEF'.indexOf(char);
}

/**
 * @summary lazily iterate over an object
 * @generator
 */
function * skip (obj) {
  for (const [k, v] of Object.entries(obj)) {
    yield [k, v];
  }
}

/**
 * @summary are the provided arguments non-conforming?
 * @returns {boolean}
 */
function invalid (r, k) {
  return !isString(r) ||
    !r.length ||
    !objNotEmpty(k);
}

/**
 * @summary is generator done?
 * @returns {boolean}
 */
function done (t) {
  return t.value === undefined || t.done;
}

/**
 * @summary bitwise AND on provided permission char and bits req'd
 * @returns {boolean}
 */
function and (p, v) {
  return !!(p & v);
}

/**
 * @summary parse permissions and build array of matches
 * @returns {array}
 */
function parse () {
  if (invalid(this.raw, this.set)) return [];

  const iter = skip(this.set);

  for (const char of this.raw) {
    const permission = getFlagsFromChar(char);

    for (let i = 0; i < 4; i++) {
      const row = iter.next();
      if (done(row)) break;

      const [k, v] = row.value;
      if (and(permission, v)) this.translated.push(k);
    }
  }
  return this.translated;
}

/**
 * @summary set lexical scope for parsing permissions strings
 */
function mapPermission (raw, key) {
  return {
    set: PERMISSIONS[key] || {},
    raw,
    translated: [],
    parse
  };
}
